import React, { useState ,useEffect} from "react";
import {
  BackArrowButton,
  CancelButton,
  ContinueButton,
  CloseButton,
} from "../../button/Button";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import styles from "./ColumnMapping.module.css";
import commonstyles from "../Forms.module.css";
import { getFixedAssetMapping } from "../../../../Bookclosure/Services/ApiHandler";
import {updateFixedAssetMapping} from "../../../../Bookclosure/Services/ApiHandler";
// const FIELDS = [
//   "Asset ID",
//   "Dep Rate",
//   "Business Area",
//   "Asset Description",
//   "Block of Asset",
//   "Capitalized On",
//   "Deactivation On",
//   "Book Value Of Deletion",
//   "Opening Gross Block",
//   "Opening Accumulated Depreciation",
//   "Terminal Value Of Asset",
//   "Opening Book Value",
//   "Acquisition Cost For Current Year Additions",
//   "Depreciation Charge For the Period",
//   "Deletion Gross Block",
//   "Deletion Depreciation",
// ];

const LABEL_FIELDS = [
  "Supplier ID",
  "Supplier Name",
  "Doc Date",
  "Due Days",
  "Due Date",
  "Foreign Currency",
  "Exchange Currency Value",
  "GL Account Code",
  "Business",
  "Business Person Responsible",
  "Provision",
  "Category",
];

// const REQUIRED_FIELDS = [
//   "Asset ID",
//   "Asset Description",
//   "Block of Asset",
//   "Deactivation On",
//   "Capitalized On",
//   "Opening Gross Block",
//   "Opening Accumulated Depreciation",
// ];

const KEY_FIELDS = [
  "supplierID",
  "supplierName",
  "docDate",
  "dueDays",
  "dueDate",
  "foreignCurrency",
  "exchangeCurrencyValue",
  "GLAccountCode",
  "business",
  "businessPersonResponsible",
  "provision",
  "category",
];

const LABEL_TO_KEY = LABEL_FIELDS.reduce((acc, label, index) => {
  acc[label] = KEY_FIELDS[index];
  return acc;
}, {});

const DEFAULT_MAPPING = {
  supplierID: "Supplier code",
  supplierName: "Supplier spmn supname",
  docDate: "Doc Date",
  dueDays: "Due days",
  dueDate: "Due date",
  foreignCurrency: "Doc Currency",
  exchangeCurrencyValue: "Exchange Rate",
  GLAccountCode: "Account Code",
  business: "Business",
  businessPersonResponsible: "Business person responsible",
  provision: "Provision",
  category: "O/s category",
};

const ColumnMapping = ({
  FixedAssetID,
  onContinue,
  onBack,
  onCancel,
  onClose,
}) => {
 const [columnOptions, setColumnOptions] = useState([]);
 
   const [mappedValues, setMappedValues] = useState(
     KEY_FIELDS.reduce((acc, key) => ({ ...acc, [key]: "" }), {})
   );
 
   const [loading, setLoading] = useState(true);
   const [apiError, setApiError] = useState(null);
 
   useEffect(() => {
     const fetchMapping = async () => {
       setLoading(true);
       setApiError(null);
 
       try {
         const response = await getFixedAssetMapping(FixedAssetID);
         const fields = response?.data?.fields || [];
 
         setColumnOptions(fields);
 
         const autoMapped = {};
         KEY_FIELDS.forEach((key) => {
           const defaultValue = DEFAULT_MAPPING[key];
           if (fields.includes(defaultValue)) {
             autoMapped[key] = defaultValue;
           }
         });
 
         setMappedValues((prev) => ({ ...prev, ...autoMapped }));
       } catch (error) {
         console.error("Error fetching sale mapping:", error);
         setApiError("Failed to load");
       }
 
       setLoading(false);
     };
 
     fetchMapping();
   }, [FixedAssetID]);
 
   const handleFieldChange = (label, value) => {
     const key = LABEL_TO_KEY[label];
     setMappedValues((prev) => ({ ...prev, [key]: value }));
   };
 
   const fieldsMapped = KEY_FIELDS.every(
     (key) => mappedValues[key] && mappedValues[key] !== ""
   );
 
   const handleSubmit = async () => {
     if (!fieldsMapped) return;
 
     try {
       setLoading(true);
       await updateFixedAssetMapping(FixedAssetID, mappedValues);
       onContinue();
     } catch (error) {
       console.error("Error updating sale mapping:", error);
       alert("Failed to Update Mapping.");
     }
 
     setLoading(false);
   };

  return (
    <div className={commonstyles.backdrop}>
      <div
        className={`${commonstyles.container} ${commonstyles.largeContainer}`}
      >
        <header className={commonstyles.header}>
          <div className={commonstyles.headerLeft}>
            <span>
              <BackArrowButton onClick={onBack} />
            </span>
            <h2 className={commonstyles.heading}>Map Column Headers</h2>
          </div>
          <CloseButton onClick={onClose} />
        </header>

        <form className={styles.gridForm}>
          {LABEL_FIELDS.map((label) => (
            <CustomDropdown
              key={label}
              label={label}
              value={mappedValues[LABEL_TO_KEY[label]] || ""}
              onChange={(value) => handleFieldChange(label, value)}
              options={columnOptions}
              placeholder="Select Column"
            />
          ))} 
        </form>

        <div className={commonstyles.footer}>
          <CancelButton onClick={onCancel} />
          <ContinueButton onClick={handleSubmit}
          disabled={!fieldsMapped || loading || apiError} />
        </div>
      </div>
    </div>
  );
};

export default ColumnMapping;
